export type ThemeMode = 'dark' | 'light';

export interface Theme {
  colors: {
    brand: string;
    brandHover: string;
    accent: string;
    bgPrimary: string;
    bgSecondary: string;
    bgTertiary: string;
    textPrimary: string;
    textSecondary: string;
    textTertiary: string;
    border: string;
    borderHover: string;
    hover: string;
    success: string;
    error: string;
    warning: string;
  };
  gradients: {
    brand: string;
    card: string;
  };
  effects: {
    gloss: string;
  };
}

export const darkTheme: Theme = {
  colors: {
    brand: '#9D4EDD',        // Electric Purple
    brandHover: '#B76EF5',   // Lighter Purple on hover
    accent: '#00F5FF',       // Cyan
    bgPrimary: '#0A0E27',    // Deep Dark Blue
    bgSecondary: '#1A1F3A',  // Dark Blue
    bgTertiary: '#252B4A',   // Medium Dark Blue
    textPrimary: '#E6E8F0',  // Light Gray
    textSecondary: '#8B92B0', // Medium Gray
    textTertiary: '#6B7280',  // Darker Gray
    border: '#2A2F45',
    borderHover: '#9D4EDD',
    hover: '#252B4A',
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
  },
  gradients: {
    brand: 'linear-gradient(135deg, #9D4EDD 0%, #00F5FF 100%)',
    card: 'linear-gradient(135deg, #1A1F3A 0%, #0A0E27 100%)',
  },
  effects: {
    gloss: 'linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
  },
};

export const lightTheme: Theme = {
  colors: {
    brand: '#7C3AED',        // Purple (slightly darker for light bg)
    brandHover: '#6D28D9',   // Darker Purple on hover
    accent: '#0891B2',       // Cyan (darker for contrast)
    bgPrimary: '#FFFFFF',    // White
    bgSecondary: '#F8FAFC',  // Light Gray
    bgTertiary: '#F1F5F9',   // Slightly darker gray
    textPrimary: '#0F172A',  // Very Dark Blue
    textSecondary: '#475569', // Medium Dark Gray
    textTertiary: '#94A3B8',  // Light Gray
    border: '#E2E8F0',
    borderHover: '#7C3AED',
    hover: '#F1F5F9',
    success: '#059669',
    error: '#DC2626',
    warning: '#D97706',
  },
  gradients: {
    brand: 'linear-gradient(135deg, #7C3AED 0%, #0891B2 100%)',
    card: 'linear-gradient(135deg, #F8FAFC 0%, #FFFFFF 100%)',
  },
  effects: {
    gloss: 'linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0) 100%)',
  },
};

// Legacy export for backward compatibility
export const theme = darkTheme;
